import { prefixLink } from '@ms/config/app'
import cookie from '@ms/utils/cookie.js'

export const getUrlOfShareTicket = (orderId = '', type = '') => {
  const uid = cookie.get('userId')
  return location.origin + prefixLink(`/share/ticket_share/${orderId}/${type}?uid=${uid}`)
}
